@if (trendChipConfig; as chip) {
  <ds-chip
    class="common-trend-chip"
    aria-hidden="true"
    data-test-id="common-trend"
    [text]="chip.text"
    [size]="chip.size"
    [colorVariant]="chip.colorVariant"
    [showIcon]="chip.showIcon"
    [iconPosition]="chip.iconPosition"
    [iconName]="chip.iconName"
  ></ds-chip>
}

<div class="visuallyhidden" data-test-id="common-trend-a11y-test">
  @if (absVariation === 0) {
    @if (config?.showNoChange === true) {
      {{ 'no_change' | translate }}
    }
  } @else {
    {{ (isPositiveTrend ? 'score-increase-message' : 'score-decrease-message') | translate: [absVariation] }}
  }
</div>
